export interface Asset {
  url: string;
  thumbnailUrl: string;
  startPoint: string;
  matchType: string;
  // The moment's EXACT offset. startPoint above is floored to whole seconds so
  // it stays invertible as hh:mm:ss, which costs up to a second - enough to
  // land the player in the shot BEFORE a short one (Igor, 2026-09-18: a 2.3s
  // Seth Rogen promo still at 61.82s floored to 61 and played the previous
  // shot). Optional because legacy search and Top Picks rows never carry it;
  // consumers fall back to inverting startPoint.
  startSeconds?: number;
}

export interface Video {
  id: string;
  url: string;
  title: string;
  description: string;
  tags: string;
  thumbnailUrl: string;
  width?: string,
  height?: string,
  format?: string,
  type?: string,
  duration: number,
  assets: Asset[];
}


export interface VideosSearchState {
  videos: Video[];
  searchText: string,
}

const initialState: VideosSearchState = {
  videos: [],
  searchText: '',
};

export { initialState };
